<div class="sidebar-header">
  <div class="header-title">
    {{ 'SETTINGS.MY_TEAM.INVITE_MEMBER_SIDEBAR.TITLE' | translate }}
  </div>
  <button mat-icon-button type="button" (click)="closeSidebar()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="sidebar-content">
  <form [formGroup]="formGroup">
    <glxy-input
      label="First name"
      [formControl]="formGroup.controls['firstName']"
    ></glxy-input>
    <glxy-input
      label="Last name"
      [formControl]="formGroup.controls['lastName']"
    ></glxy-input>
    <glxy-email-input
      [required]="true"
      label="Email"
      [formControl]="formGroup.controls['email']"
    ></glxy-email-input>
    <glxy-phone-input
      label="Phone"
      [formControl]="formGroup.controls['phone']"
    ></glxy-phone-input>
  </form>
</div>
<div class="sidebar-footer">
  <button mat-button color="primary" (click)="closeSidebar()">
    {{ 'SETTINGS.MY_TEAM.INVITE_MEMBER_SIDEBAR.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    [disabled]="formSubmitting$ | async"
  >
    {{ 'SETTINGS.MY_TEAM.INVITE_MEMBER_SIDEBAR.SEND' | translate }}
  </button>
</div>
